export const getFullNameInitials = (fullName: string | undefined) => {
  if (fullName?.includes("@")) {
    return fullName
      .split(".")
      .map((name) => name.charAt(0).toUpperCase())
      .join("");
  }

  return typeof fullName === "string"
    ? fullName
        .split(" ")
        .map((name) => name.charAt(0).toUpperCase())
        .join("")
    : "";
};
